import { render, staticRenderFns } from "./inspected.vue?vue&type=template&id=0554df08&"
import script from "./inspected.vue?vue&type=script&lang=js&"
export * from "./inspected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports